
import { Prop, Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GroupScope } from '@/components/mixins/groupscope';
import { GroupSchemeScope } from '@/components/mixins/schemescope';
import { Badge } from '@/models/group';
import { Member } from '@/models/member';
import moment from 'moment';

@Component({
  name: 'MemberBadge',
})
export default class MemberBadge extends mixins(GroupScope, GroupSchemeScope) {
  @Prop() member!: Member;
  @Prop() badge!: Badge;

  private loading = false;

  /**
   * Created hook, runs before component is mounted.
   * Makes sure the relevant group information is fetched from the IDB/API for this and nested pages.
   *
   * @return {void}
   */
  created(): void {
    this.loadGroup();
  }

  getMemberLinkName(member: Member): string {
    return member.firstname.toLowerCase() + '-' + member.lastname.toLowerCase();
  }

  get memberHasBadge() {
    return this.member.badges && this.member.badges.find(ba => ba.badge_id === this.badge.ngo_id);
  }

  get badgeAchievedDate() {
    const badge = this.memberHasBadge;
    if (!badge) {
      return '';
    }
    return moment(badge.achieve_date).format('MMM Do YYYY');
  }

  async awardBadge() {
    this.loading = true;
    const success = await this.$store.dispatch('groupMembers/awardBadge', {
      member: this.member,
      group: this.group,
      badgeId: this.badge.ngo_id,
    });
    if (success === true) {
      this.$alert('success', this.$t('badges.award_badge_success'));
    } else {
      this.$alert('error', this.$t('badges.award_badge_failed'));
    }
    this.loading = false;
  }

  async removeBadge() {
    this.loading = true;
    const success = await this.$store.dispatch('groupMembers/removeBadge', {
      member: this.member,
      group: this.group,
      badgeId: this.badge.ngo_id,
    });
    if (success === true) {
      this.$alert('success', this.$t('badges.remove_badge_success'));
    } else {
      this.$alert('error', this.$t('badges.remove_badge_failed'));
    }
    this.loading = false;
  }
}
